
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_7rxzl_17",
  "full-width": "awsui_full-width_8cbea_7rxzl_44",
  "refresh": "awsui_refresh_8cbea_7rxzl_47",
  "disabled": "awsui_disabled_8cbea_7rxzl_53",
  "selected": "awsui_selected_8cbea_7rxzl_113",
  "icon": "awsui_icon_8cbea_7rxzl_126",
  "with-text": "awsui_with-text_8cbea_7rxzl_130",
  "with-no-text": "awsui_with-no-text_8cbea_7rxzl_139",
  "root": "awsui_root_8cbea_7rxzl_144",
  "segment-part": "awsui_segment-part_8cbea_7rxzl_176",
  "grouped": "awsui_grouped_8cbea_7rxzl_200",
  "grouped-only": "awsui_grouped-only_8cbea_7rxzl_200",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_7rxzl_204",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_7rxzl_215",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_7rxzl_219",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_7rxzl_225",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_7rxzl_229",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_7rxzl_233",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_7rxzl_239",
  "select": "awsui_select_8cbea_7rxzl_113",
  "segment-count-2": "awsui_segment-count-2_8cbea_7rxzl_256",
  "segment-count-3": "awsui_segment-count-3_8cbea_7rxzl_263",
  "segment-count-4": "awsui_segment-count-4_8cbea_7rxzl_270",
  "segment-count-5": "awsui_segment-count-5_8cbea_7rxzl_277",
  "segment-count-6": "awsui_segment-count-6_8cbea_7rxzl_284",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_7rxzl_291"
};
  